import { Box, styled, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledGreenButton, StyledMediumTypography } from '../../theme/StyledElements';

const StyledMessageBox = styled(Box)(() => ({
    marginTop: '10px',
    textAlign: 'center'
}));

const StyledInformationButton = styled(StyledGreenButton)(() => ({
    width: '150px',
    height: '35px',
    background: '#134C03',
    borderRadius: '4px',
    color: '#FFFFFF',
    padding: '15px',
    marginTop: '20px',
    '&:hover': {
        boxShadow: 'none',
        background: '#134C03',
        color: '#FFFFFF'
    }
}));

interface MessageTimerComponentProps {
    timer: number[];
    onDeleteClick: Function;
}

export function MessageTimerComponent({
    timer,
    onDeleteClick
}: MessageTimerComponentProps): JSX.Element {
    const { t } = useTranslation();
    return (
        <StyledMessageBox>
            <StyledMediumTypography variant="h1" color="#134C03">
                {timer[0]}h{timer[1]}
            </StyledMediumTypography>
            <Typography variant="subtitle2" color="#134C03">
                {t('beforeEndOfMessage')}
            </Typography>
            <StyledInformationButton onClick={(): void => onDeleteClick()}>
                <Typography variant="caption" color="#FFFFFF">
                    {t('toDelete')}
                </Typography>
            </StyledInformationButton>
        </StyledMessageBox>
    );
}
